import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aitrading.onrender.com';

export const fetchYahoo = ({ symbols, period = '1mo', interval = '5m', resample = '5T' }) => {
  return axios.post(`${API_BASE_URL}/forecast/fetch-yf`, {
    symbols,
    period,
    interval,
    resample
  });
};

export const previewSession = (sessionId) => {
  return axios.get(`${API_BASE_URL}/forecast/preview/${sessionId}`);
};


